module.exports = __webpack_public_path__ + "img/20200801_131327.3312ec6f.jpg";